import { Users, TrendingUp, DollarSign, History } from 'lucide-react';

export function RoyaltyStats({ tokenHolders, totalOwnership, totalDistributed, royaltyHistory }) {
  return (
    <div className="grid md:grid-cols-4 gap-4">
      <div className="glass-card p-4">
        <div className="flex items-center gap-2 mb-2">
          <Users className="w-4 h-4 text-cyan-400" />
          <span className="text-sm text-gray-400">Token Holders</span>
        </div>
        <p className="text-2xl font-bold">{tokenHolders.length}</p>
      </div>
      <div className="glass-card p-4">
        <div className="flex items-center gap-2 mb-2">
          <TrendingUp className="w-4 h-4 text-purple-400" />
          <span className="text-sm text-gray-400">Ownership Sold</span>
        </div>
        <p className="text-2xl font-bold">{totalOwnership}%</p>
      </div>
      <div className="glass-card p-4">
        <div className="flex items-center gap-2 mb-2">
          <DollarSign className="w-4 h-4 text-green-400" />
          <span className="text-sm text-gray-400">Total Distributed</span>
        </div>
        <p className="text-2xl font-bold text-green-400">${totalDistributed.toFixed(2)}</p>
      </div>
      <div className="glass-card p-4">
        <div className="flex items-center gap-2 mb-2">
          <History className="w-4 h-4 text-yellow-400" />
          <span className="text-sm text-gray-400">Distributions</span>
        </div>
        <p className="text-2xl font-bold">{royaltyHistory.length}</p>
      </div>
    </div>
  );
}
